<template>
  <div class="mobile-wrap">
    <div class="title">Уверены что хотите удалить?</div>
    <div class="btn-wrap">
      <button class="btn btn-outline-primary" @click="$emit('close')">Нет</button>
      <button class="btn btn-primary" @click="onDelete">Да</button>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const {mapActions} = createNamespacedHelpers('posts')

  export default {
    name: 'ConfirmPostRemove',
    props: ['eventId', 'postId'],
    methods: {
      ...mapActions(['delete_post']),
      async onDelete() {
        const obj = {
          event_id: this.eventId,
          post_id: this.postId
        }
        await this.delete_post(obj)
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss">
  .mobile-wrap {
    padding: 40px;

    .btn-wrap {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 16px;
      margin-top: 40px;

      .btn {
        padding-top: 16px;
        padding-bottom: 16px;
      }
    }

    .title {
      font-weight: bold;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 36px;
    }
  }
</style>
